import {util} from "node-forge";

export class RsaHelper {
    private static RSA_OAEP_ALGORITHM = "RSA-OAEP";
    private static RSA_OAEP_MODULUS_LENGTH = 2048;
    private static RSA_OAEP_PUBLIC_EXPONENT = new Uint8Array([0x01, 0x00, 0x01]); // 65537
    private static RSA_OAEP_HASH_ALGORITHM_SHA256 = "SHA-256";
    private static RSA_OAEP_KEY_USAGES: KeyUsage[] = ["encrypt", "decrypt"];

    public async generateKeyPair(): Promise<{
        publicKey: string;
        privateKey: string;
    }> {
        const keyPair = await window.crypto.subtle.generateKey(
            {
                name: RsaHelper.RSA_OAEP_ALGORITHM,
                modulusLength: RsaHelper.RSA_OAEP_MODULUS_LENGTH,
                publicExponent: RsaHelper.RSA_OAEP_PUBLIC_EXPONENT,
                hash: { name: RsaHelper.RSA_OAEP_HASH_ALGORITHM_SHA256 },
            },
            true,
            RsaHelper.RSA_OAEP_KEY_USAGES
        );

        const publicKeyDer = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
        const privateKeyDer = await window.crypto.subtle.exportKey("pkcs8", keyPair.privateKey);

        const publicKeyBase64 = RsaHelper.arrayBufferToBase64(publicKeyDer);
        const privateKeyBase64 = RsaHelper.arrayBufferToBase64(privateKeyDer);

        const publicKeyFormatted = RsaHelper.chunkString(publicKeyBase64, 64);

        const publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${publicKeyFormatted}\n-----END PUBLIC KEY-----`;
        const privateKeyPem = `-----BEGIN PRIVATE KEY-----${privateKeyBase64}-----END PRIVATE KEY-----`;


        const publicKey= encodeURIComponent(publicKeyPem).replace(/%20/g, "+");
        const privateKey= privateKeyPem;

        return { publicKey, privateKey};
    }

    private static arrayBufferToBase64(buffer: ArrayBuffer): string {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    private static chunkString(str: string, length: number): string {
        return str.match(new RegExp(`.{1,${length}}`, "g"))?.join("\n") || "";
    }
}